export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/femalebody.764cd61b.svg","height":441,"width":229,"blurWidth":0,"blurHeight":0};